export const primaryTextColor = (primaryColor?: string) => ({
  color: primaryColor,
});

export const teamLogoBorderColor = (orgColor?: string) => ({
  borderColor: orgColor || '#e9ecf3',
});
